import React from 'react';
import useSelector from 'components/Booking-new/hooks';
import { Content } from './styles';

const FreeParkingHeading = () => {
  const { results } = useSelector(state => ({
    content: state.config?.freeParking?.heading,
  }));

  if (!results.content) return null;

  return (
    <Content variant="DS_copyMediumRegular" component="p">
      {results.content}
    </Content>
  );
};

export default FreeParkingHeading;
